import { ConfigApi } from '@backstage/core-plugin-api';
import { KubernetesTableData } from './types';
import { KubernetesResourceDetails } from '@internal/backstage-plugin-compute-resource-discovery-new-common';

export const mapResourcesToKubernetesTableData = (
  resources: KubernetesResourceDetails[],
): KubernetesTableData[] => {
  return resources.map(resource => {
    const baseData = {
      identifier: resource.identifier,
      kind: resource.kind,
      name: resource.name,
      namespace: resource.namespace,
      replicas: resource.replicas,
      ready: resource.ready,
      status: resource.status,
      previousDesiredSize: resource.previousDesiredSize,
    };
    return baseData;
  });
};

export function getTeleportDocsUrl(config: ConfigApi): string | undefined {
  const techdocsUrl = config.getOptionalConfig('techdocsUrl');
  return techdocsUrl?.getOptionalString('teleport');
}

export function getK9sDocsUrl(config: ConfigApi): string | undefined {
  const techdocsUrl = config.getOptionalConfig('techdocsUrl');
  return techdocsUrl?.getOptionalString('k9s');
}
